import React from "react"

import { Flex, Segmented } from "antd"
import { useSelector } from "react-redux"

import InviteByEmail from "./InviteByEmail"
import ShareLink from "./ShareLink"

const content = {
  "Share link": <ShareLink />,
  "Invite by email": <InviteByEmail />
}

const Share = () => {
  const isMobile = useSelector((state) => state.nav.isMobile)
  const [option, setOption] = React.useState("Share link")

  return (
    <div>
      <Segmented
        value={option}
        style={{ marginBottom: 24, width: isMobile && "100%" }}
        onChange={setOption}
        options={["Share link", "Invite by email"]}
      />
      <Flex vertical>{content[option]}</Flex>
    </div>
  )
}

export default Share
